export const PRESET_TICKERS = ['SPX', 'SPY', 'NVDA', 'AAPL', 'MSFT', 'AMZN', 'GOOG', 'META', 'TSLA', 'WMT', 'MU', 'PLTR', 'AMD'];
export const TICKERS_STORAGE_KEY = 'options-custom-tickers';
